import { createAction, props } from '@ngrx/store'

export const changeCurrentRoute = createAction(
  '[Router] Change Current Route',
  props<{ newCurrentRoute: String }>()
)

export const navigateBusinessDashboard = createAction(
  '[Router] Navigate Business Dashboard'
)

export const navigateLocationDashboard = createAction(
  '[Router] Navigate Location Dashboard'
)

export const navigateAuth = createAction(
  '[Router] Navigate Auth'
)

export const navigateSignUpProcess = createAction(
  '[Router] Navigate Signup Process'
)

export const navigatePasswordRecover = createAction(
  '[Router] Navigate Password Recover'
)

export const navigateChangePassword = createAction(
  '[Router] Navigate Change Password'
)

export const navigateChangePasswordConfirmed = createAction(
  '[Router] Navigate Change Password Confirmed'
)

export const navigateContacts = createAction(
  '[Router] Navigate Contacts',
  props<{ urlParam: String }>()
)

export const navigateUsers = createAction(
  '[Router] Navigate Users',
  props<{ urlParam: String }>()
)

export const navigateReviewTargets = createAction(
  '[Router] Navigate Review Targets'
)

export const navigateReviewTargetsLocation = createAction(
  '[Router] Navigate Review Targets Location'
)

export const navigateReviewTargetsForm = createAction(
  '[Router] Navigate Review Targets Form'
)

export const navigateResellers = createAction(
  '[Router] Navigate Resellers'
)

export const navigateResellerProfile = createAction(
  '[Router] Navigate Reseller Profile'
)

export const navigateReports = createAction(
  '[Router] Navigate Reports'
)

export const navigateReviews = createAction(
  '[Router] Navigate Reviews'
)

export const navigateFeedback = createAction(
  '[Router] Navigate Feedback'
)

export const navigateCampaigns = createAction(
  '[Router] Navigate Campaigns'
)

export const navigateTemplates = createAction(
  '[Router] Navigate Templates'
)

export const navigateWidgets = createAction(
  '[Router] Navigate Widgets'
)

export const navigateSharing = createAction(
  '[Router] Navigate Sharing'
)

export const navigateTo = createAction(
  '[Router] Navigate To',
  props<{ pathUrl: string, queryParams?: { [key: string]: string } }>()
)
